<template>
  <div class="sky-change-role">
    <div class="wsp-line-height-36">
      <div class="wsp-display-flex">
        <div class="wsp-width-30 wsp-text-align-right"><strong>角色：</strong></div>
        <div class="wsp-width-70">
          <el-radio-group v-model="roleId">
            <el-radio-button v-for="(item, index) in rowArr" :label="item.id" :key="index">{{
              item.roleName
            }}</el-radio-button>
          </el-radio-group>
        </div>
      </div>
    </div>
    <div style="text-align: center; margin-top: 10px;">
      <el-button class="sky-branch-pattern__add" style="margin-top:5px" type="success" @click="changeRole">
        确认变更
      </el-button>
      <el-button class="sky-branch-pattern__add" style="margin-top:5px" @click="cancelChange">
        取消变更
      </el-button>
    </div>
  </div>
</template>
<script type="text/babel">
import { Input, Button, RadioButton, RadioGroup } from 'element-ui'

import { changeRoleValue } from '@/api/login'
import { getRoleList } from '@/api/setting'

export default {
  name: 'SkyChangeRole',
  components: {
    [Input.name]: Input,
    [RadioButton.name]: RadioButton,
    [Button.name]: Button,
    [RadioGroup.name]: RadioGroup
  },
  props: {
    crmOrderId: {},
    fromCtrl: null
  },
  data() {
    return {
      roleId: null,
      nowRoleName: null,
      rowArr: []
    }
  },
  created() {
    getRoleList({}).then(res => {
      for (const element of this.rowArr) {
        if (element.rowName === '管理员') {
          this.roleId = element.id
        }
      }
      this.rowArr = res.data.content.itemArr
    })
  },
  mounted() {},
  methods: {
    changeRole() {
      changeRoleValue({ roleId: this.roleId }).then(res => {
        window.location.reload()
      })
    },
    cancelChange() {
      this.$emit('cb')
    }
  },

  beforeDestroy() {
    this.$emit('cb')
  }
}
</script>
<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';

@include b(change-role) {
}
</style>
